import type { IconProps } from './types';

const CheckBoldIcon = (props: IconProps) => {
  const { color = 'currentColor', size = 24, ref, ...other } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      {...other}
      ref={ref}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        d="M20.3658 6.12477L9.51821 19.7142L4.08008 14.2639L6.15593 12.1834L9.2745 15.308L18.073 4.28564L20.3658 6.12477Z"
        fill={color}
      />
    </svg>
  );
};

export { CheckBoldIcon };
